module.exports = __webpack_public_path__ + "img/typhoon-logo.58d54d06.png";